import { TOGGLE_SEGMENT_SETTINGS } from "../types";

const initialState = {
  segmentSettingsEnabled: false,
};

const settingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_SEGMENT_SETTINGS:
      return {
        ...state,
        segmentSettingsEnabled: action.payload,
      };
    default:
      return state;
  }
};

export default settingsReducer;
